import styled from 'styled-components';

export const HistoryContainer = styled.div`
  padding: 16px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;

`;

export const HistoryWrapper = styled.div`
  padding: 12px;
  cursor: pointer;
  margin-bottom: 8px;
  position: relative;
  min-height: 60px;
  background-color: ${props => props.theme.colors.highClearGray};
  border-radius: 8px;
`;

export const HistoryText = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.black};
  margin-bottom: 4px;
`;

export const HistoryDateWrapper = styled.div`
  position: absolute;
  left: 12px;
  bottom: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HistoryDate = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.dune};
`;

export const MessageCount = styled.div`
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid ${props => props.theme.colors.clearGray};
  padding: 2px 8px;
  color: ${props => props.theme.colors.dune};
`;

export const NoConversationsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: ${props => props.theme.colors.clearGray};
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y:auto;
    scrollbar-width: thin;
`